import * as _ from "lodash";
import * as $ from "jquery";

import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { GfxUtils, NodeType } from "../../../common/gfxUtils";
import { ColorConstants } from "../../../common/constants";
import { UiUtils } from "../../../common/uiUtils";
import { Misc } from "../../../common/misc";
import { GeometryTools } from "../../../common/geometryTools";
import { BalconyGroup, BalconyInfo, BalconyPanel } from "./balconyInfo";
import { StepVisualizer } from "./stepVisualizer";
import { ShareUtils } from "../../share/shareUtils";

enum CopyStep {
    None,
    Direction,
    Copy,
    Finish
}

interface CopyProps {
    viewer: Autodesk.Viewing.GuiViewer3D;
    selectedBalconyId: number;
    copyBalconies: (direction: number, offset: number, amount: number) => void;
    closeWizard: () => void;
    originalModelId: number;
    panelsModelId: number;
    gfxUtils: GfxUtils;
}

export function CopySteps(props: CopyProps) {
    const [directionChecked, setDirectionChecked] = useState(false);
    const [offset, setOffset] = useState("");
    const [amount, setAmount] = useState("");
    const [step, setStep] = useState(CopyStep.Direction);
    const [selectedBalconyId, setSelectedBalconyId] = useState<number>(props.selectedBalconyId);
    const [helpText, setHelpText] = useState("");

    useEffect(() => {
        //showMeasurementTool();
    }, []);

    useEffect(() => {
        setStep(CopyStep.Direction);
    }, [selectedBalconyId]);

    useEffect(() => {
        switch (step) {
            case CopyStep.Direction:
                //props.viewer.clearSelection();
                setHelpText("Select the direction where the objects will be copied");
                break;
            case CopyStep.Copy:
                setHelpText("Select offset and the number of objects to copy");
                break;
            case CopyStep.Finish:
                setHelpText("Add copied balconies");
                break;
            default:
                setHelpText("This is an area for help texts");
        }
    }, [step]);

    const directionChanged = () => setDirectionChecked(!directionChecked);

    return (
        <div id="steps-react" className="react-content m-1">
            <div>
                <div className="row pt-1 pb-2">
                    <div className="col d-flex justify-content-center">
                        <StepVisualizer steps={["Direction", "Amount", "Save"]} currentStep={step} />
                    </div>
                </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center mt-1 mb-2 border border-white" style={{ height: "50px" }}>
                <span style={{ fontSize: "medium" }}>{helpText}</span>
            </div>

            {step === CopyStep.Direction &&
                <div className="row d-flex py-2 justify-content-center">
                    <div className="custom-control custom-switch">
                        <input type="checkbox" className="custom-control-input" id="directionSwitch"
                            checked={directionChecked}
                            onChange={directionChanged} />
                        <label className="custom-control-label" htmlFor="directionSwitch">Copy to negative z-direction</label>
                    </div>
                </div>
            }
            {step === CopyStep.Copy &&
                <form className="sdCopy">
                    <div className="form-row py-2 align-items-center justify-content-center">
                        <div className="form-group col-4">
                            <input type="number" className="form-control" id="sdOffset" placeholder="Offset [mm]" min="1"
                                value={offset} onChange={evt => setOffset(evt.target.value)} />
                        </div>
                        <div className="form-group col-4">
                            <input type="number" className="form-control" id="sdAmount" placeholder="Amount [pcs]" min="1"
                                value={amount} onChange={evt => setAmount(evt.target.value)} />
                        </div>
                    </div>
                </form>
            }

            <div className="row align-items-center justify-content-between py-1">
                <div className="col">
                    <button id="cancel" className="btn btn-secondary"
                        onClick={(e) => {
                            props.closeWizard();
                        }}>
                        Cancel
                    </button>
                </div>
                <div className="col">
                    <button id="stop1" className="btn btn-primary float-right"
                        disabled={step == CopyStep.Copy && (offset.length == 0 || amount.length == 0)}
                        onClick={async (e) => {
                            setStep((prev) => prev + 1);
                            switch (step) {
                                case CopyStep.Direction:
                                    break;
                                case CopyStep.Copy:
                                    break;
                                case CopyStep.Finish:
                                    props.copyBalconies(directionChecked ? -1 : 1, Number(offset), Number(amount));
                                    setStep(CopyStep.None);
                                    break;
                                default:
                            }
                        }}>
                        {step < CopyStep.Finish ? "Next" : "Add"}
                    </button>
                </div>
            </div>
        </div>
    );
}